var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28571 20.5238H28.4286C29.0348 20.5238 29.6162 20.283 30.0448 19.8544C30.4735 19.4257 30.7143 18.8443 30.7143 18.2381V3.28571C30.7143 2.67951 30.4735 2.09812 30.0448 1.66947C29.6162 1.24082 29.0348 1 28.4286 1H3.28571C2.67951 1 2.09812 1.24082 1.66947 1.66947C1.24082 2.09812 1 2.67951 1 3.28571L1 18.2381C1 18.8443 1.24082 19.4257 1.66947 19.8544C2.09812 20.283 2.67951 20.5238 3.28571 20.5238Z",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85742 1.19141V20.5247",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4219 14.6264L27.1911 10.8571L23.4219 7.08789",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1914 10.8574H13.1914",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavExpandIcon);
export default __webpack_public_path__ + "static/media/sidenav-expand-icon.f6993da7bb7b9f72a383d512d8eb4d39.svg";
export { ForwardRef as ReactComponent };